import { render } from "./AddUserLocation.vue?vue&type=template&id=4d2df36f&scoped=true&ts=true"
import script from "./AddUserLocation.vue?vue&type=script&lang=ts"
export * from "./AddUserLocation.vue?vue&type=script&lang=ts"

import "./AddUserLocation.vue?vue&type=style&index=0&id=4d2df36f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2df36f"]])

export default __exports__